module.exports = __webpack_public_path__ + "45297f5ecb1711ded560b8e5b19bd6de.svg";